import { render, staticRenderFns } from "./Deta.vue?vue&type=template&id=430f5b9a&scoped=true&"
import script from "./Deta.vue?vue&type=script&lang=js&"
export * from "./Deta.vue?vue&type=script&lang=js&"
import style0 from "./Deta.vue?vue&type=style&index=0&id=430f5b9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430f5b9a",
  null
  
)

export default component.exports